module.exports = {"id":"193092","name":"Marco Rojas","rating":"71","photo":"./data/images/photos/3/193092.png","club":{"name":"sc Heerenveen","logo":"./data/images/clubs/scHeerenveen.png"},"positions":["AD","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoRojas0.json
// module id = 2746
// module chunks = 0